import { User } from "@/@types/sintegrada/User";
import { getSintegradaServerApi } from "@/services/api";

type ProfissionalMedicalAttendanceParams = {
	uf: string;
	ibgeCode: string;
	cnes?: string;
	professionalName?: string;
	professionalCns?: string;
	professionalId?: number;
};

export async function getProfissionalMedicalAttendance({
	...params
}: ProfissionalMedicalAttendanceParams) {
	const response = await getSintegradaServerApi().get<User[]>(
		`/medical-attendances/professional`,
		params
	);
	return response.data || [];
}
